import React, { useEffect, useState } from "react";


import CreatePropertyModal from "js/components/Properties/ModernPropertyModal/CreatePropertyModal";
import { PropertyDetails } from "js/components/Tenants/TenantReportDetails/typing";
import { Property } from "js/components/types";
import { Button } from "js/components/ui/button";
import {
  DescriptionList,
  DescriptionItem,
} from "js/components/ui/description-list";
import { formatCurrency, toTitleCase } from "../../../../utils/utils";

interface PropertyDetailsProps {
  property: PropertyDetails;
  onUpdate?: (updatedProperty: PropertyDetails) => void;
  folio?: string;
  isModalOpen?: boolean;
  onModalOpenChange?: (open: boolean) => void;
}

const PropertyDetailsComponent: React.FC<PropertyDetailsProps> = ({
  property,
  onUpdate,
  isModalOpen: externalModalOpen,
  onModalOpenChange,
}) => {
  const [internalModalOpen, setInternalModalOpen] = useState(false);
  const hasExternalModalControl =
    externalModalOpen !== undefined && onModalOpenChange !== undefined;
  const isModalOpen = hasExternalModalControl
    ? externalModalOpen
    : internalModalOpen;
  const setIsModalOpen = hasExternalModalControl
    ? onModalOpenChange
    : setInternalModalOpen;
  const [propertyId, setPropertyId] = useState("");
  const [propertyData, setPropertyData] = useState<Property[]>([]);

  useEffect(() => {
    if (isModalOpen) {
      setPropertyId(property.id || "");
      setPropertyData([property as unknown as Property]);
    }
  }, [isModalOpen, property]);

  const handlePropertyUpdate = (updatedProperties: Property[]) => {
    const updatedProperty = updatedProperties.find((p) => p.id === property.id);
    if (updatedProperty && onUpdate) {
      onUpdate(updatedProperty as unknown as PropertyDetails);
    }
    setPropertyData(updatedProperties);
  };

  if (!property) {
    return null;
  }

  const fullAddress = toTitleCase(
    `${property.address?.street} ${property.address?.exterior_number} ${property.address?.interior_number ? property.address?.interior_number : ""}, ${property.address?.neighborhood}, ${property.address?.zip_code}, ${property.address?.city}, ${property.address?.state}`,
  );

  return (
    <>
      {!property.verified && !hasExternalModalControl && (
        <div className="mb-4 flex justify-end">
          <Button variant="ghost" size="sm" onClick={() => setIsModalOpen(true)}>
            Editar
          </Button>
        </div>
      )}

      <DescriptionList>
        <DescriptionItem label="Dirección">{fullAddress}</DescriptionItem>
        {property.alias && (
          <DescriptionItem label="Alias del inmueble">
            {toTitleCase(property.alias ?? "")}
          </DescriptionItem>
        )}
        <DescriptionItem label="Valor mensual de la renta">
          {formatCurrency(property?.rental_price)}
        </DescriptionItem>
        <DescriptionItem label="Valor mensual del mantenimiento">
          {formatCurrency(property?.maintenance_price) ?? "$0"}
        </DescriptionItem>
      </DescriptionList>

      <CreatePropertyModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        propertyId={propertyId}
        setPropertyId={setPropertyId}
        propertyData={propertyData}
        setPropertyData={handlePropertyUpdate}
      />
    </>
  );
};

export default PropertyDetailsComponent;
